import { render, staticRenderFns } from "./Semaforo-add.vue?vue&type=template&id=105453d6"
import script from "./Semaforo-add.vue?vue&type=script&lang=js"
export * from "./Semaforo-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports